import React, {useEffect, useRef, useState, useContext, useMemo} from 'react'
import {IconButton} from '@material-ui/core'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import AddRoundedIcon from '@material-ui/icons/AddRounded'
import useCalendarViewContext from '../../../context/CalendarView'
import LoadingIndicator from '../../ReservationConfiguration/LoadingIcon'
import {ReservationCalendarMainContext} from '../../../context/ReservationCalendarMain'
import ShareableViewItem from './ShareableViewItem'
import _ from 'lodash'
import ShareableViewPopup from './ShareableViewPopup'
import {Colors} from './../ColorPicker'
import {useBanner} from './Banner'
import AddIcon from './Add.svg'
import RightArrow from './right-arrow.svg'
import ExpandArrow from './expand-arrow.svg'

const ShareableView = () => {
  const {
    views,
    groups,
    loadCalendarViews,
    viewData,
    setViewData,
    shareableViewData,
    setShareableViewData,
    data,
    shareableViews,
    loadShareableCalendarViews,
    setSharableFilters,
    currentView,
    setCurrentView,
  } = useCalendarViewContext()
  const banner = useBanner({})
  const {calendarView} = useContext(ReservationCalendarMainContext)
  const [showPopShareableView, setShowPopShareableView] = useState(null)
  const refHead = useRef(null)
  const [viewExpand, setViewExpand] = useState(false)
  const [editInfo, setEditInfo] = useState({})
  const list = shareableViews?.data
  const [currentColor, setCurrentColor] = useState('')
  const [currentViewId, setCurrentViewId] = useState('')

  const customColors = useMemo(() => {
    let _colors = []
    _.each(views.data, v => {
      _colors.push(v.group_view.color)
      _.each(v.group_view.calendar_child_view, cv => {
        _colors.push(cv.color)
      })
    })
    return _.difference(_.uniq(_colors), Colors)
  }, [views])

  const handleAddSuccess = (updates, view_data = null) => {
    setShowPopShareableView(null)
    loadShareableCalendarViews()
    if (view_data) {
      let groupData = {
        group_view: view_data,
      }
      if (currentViewId === view_data._id['$oid']) {
        setShareableViewData(data => {
          let _selectedFilteredViews = data.selectedFilteredViews
          return {
            selectedView: groupData,
            selectedFilteredViews: _selectedFilteredViews,
            is_shareable_view: true,
          }
        })
      }
    }

    if (!_.isEmpty(editInfo.id) && updates !== 'delete') {
      if (banner) {
        banner.show({
          scheme: 'success',
          title: `Changes to ${editInfo.name} have been saved! Depending on your calendar provider, it may take up to 24 hours to update your external calendars.
          `,
        })
      }
      setEditInfo({})
    }
  }

  useEffect(() => {
    loadShareableCalendarViews()
    //eslint-disable-next-line
  }, [])

  const openSharableViewPopup = () => {
    setSharableFilters([])
    setShowPopShareableView(true)
    setShareableViewData({
      ...shareableViewData,
      selectedFilterValueFields: [],
      is_shareable_view: false,
    })
    setEditInfo({})
  }

  const onClickEdit = (e, data) => {
    setSharableFilters([])
    setShowPopShareableView(true)
    setShareableViewData({
      ...shareableViewData,
      selectedFilterValueFields: [],
      is_shareable_view: false,
    })
    setEditInfo(data)
  }

  const handleClickView = (e, view, color) => {
    setCurrentView(view.group_view.name)
    setCurrentViewId(view.group_view.id['$oid'])
    setCurrentColor(color)
    setShareableViewData(data => {
      let _selectedFilteredViews = data.selectedFilteredViews
      // check if same view
      // if (data.selectedView === view) {
      //   // if has child or child exists
      //   if (!!data.selectedFilteredView) {
      //     return {
      //       ...data,
      //       selectedFilteredViews: [],
      //     }
      //   } else {
      //     return {
      //       selectedView: {},
      //       selectedFilteredViews: [],
      //     }
      //   }
      // }
      return {
        selectedView: view,
        selectedFilteredViews: _selectedFilteredViews,
        is_shareable_view: true,
      }
    })
    setViewData({
      selectedView: {},
      selectedFilteredViews: [],
    })
  }

  return (
    <div style={{marginTop: 16}} hidden={calendarView === 'reservation'}>
      <div
        ref={refHead}
        className="ap-flex ap-flex--align-center"
        style={{padding: '0 16px 0 16px'}}
      >
        <div className="ap-flex" style={{minWidth: '150px', marginBottom: 8}}>
          <span style={{color: '#303A52'}} className="ap-typography ap-typography--lg">
            Shareable views
          </span>
        </div>
        <div className="ap-flex ap-flex--end mt--5">
          <IconButton
            size="small"
            className="ap-icon-button ap-icon-button--square"
            style={{
              color: list.length < 3 ? '#596175' : '#00000042',
              marginRight: 4,
              opacity: list.length < 3 ? '1' : '0.5',
            }}
            onClick={e => list.length < 3 && openSharableViewPopup()}
            disabled={list.length < 3 ? false : true}
          >
            <img alt="AddIcon" src={AddIcon} style={{width: 20, height: 20}} />
          </IconButton>
          <IconButton
            size="small"
            className="ap-icon-button ap-icon-button--square"
            style={{color: '#596175', marginLeft: 4}}
            onClick={() => setViewExpand(!viewExpand)}
          >
            {viewExpand ? (
              <img alt="RightArrow" src={RightArrow} className="down-arrow" />
            ) : (
              <img alt="ExpandArrow" src={ExpandArrow} className="down-arrow" />
            )}
          </IconButton>
        </div>
      </div>

      <div className="c-calendar-views__list" hidden={viewExpand}>
        {shareableViews.isLoading && <LoadingIndicator />}
        {!shareableViews.isLoading &&
          _.map(list, (e, i) => (
            <ShareableViewItem
              data={e.group_view}
              onClickEdit={onClickEdit}
              onClickView={handleClickView}
              selectedView={shareableViewData.selectedView}
              selectedFilteredView={shareableViewData.selectedFilteredViews}
              viewData={e}
              currentView={currentView}
              currentColor={currentColor}
            />
          ))}
      </div>
      {showPopShareableView && (
        <ShareableViewPopup
          open={!!showPopShareableView}
          data={data}
          groups={groups}
          onClose={e => setShowPopShareableView(null)}
          viewData={views.data}
          onSuccess={handleAddSuccess}
          customColors={customColors}
          shareableViews={shareableViews?.data}
          setEditInfo={setEditInfo}
          editInfo={editInfo}
          setCurrentColor={setCurrentColor}
        />
      )}
    </div>
  )
}

export default ShareableView
